export const features = [
  {
    icon: "🎨", // Icon updated
    title: "Tailored Layouts",
    description:
      "Customize your resume design to match your professional style with flexible layout options.",
    link: "Explore Customizable Options",
    to: "/templates",
  },
  {
    icon: "🌈", // Icon updated
    title: "Versatile Templates",
    description:
      "Choose from a variety of templates that cater to different career fields and personal preferences.",
    link: "View All Templates",
    to: "/templates",
  },
  {
    icon: "💡", // Icon updated
    title: "Intuitive Interface",
    description:
      "Easily create and update your resume with our user-friendly tools and streamlined design.",
    link: "Start Designing Now",
    to: "/templates",
  },
  {
    icon: "📝", // New Feature: Spelling Checker
    title: "Smart Spelling Suggestions",
    description:
      "Detect and correct spelling errors with intelligent suggestions to ensure a polished, professional resume.",
    link: "Check Your Resume",
    to: "/resume/maker",
  },
];
